/* M-050 fix 2026-08-23 — atomic cart sync + gated checkout navigation + 429 backoff + toast.
   M-052 fix 2026-08-23 — extends the above: never sync/keep an unsellable variant, self-heal
   localStorage + fire atlas-cart-change so the React cart re-renders (fixes the lying cart total),
   toast naming what was removed, and the checkout gate refuses to navigate on an empty post-purge
   target with a toast distinguishable from the network-failure toast. See notes file.
   CART-002 draft 2026-08-30 - (1) the unknown-variant default flips to UNSELLABLE when the live feed
   actually delivered variants, so a stale localStorage line for a hidden product self-purges instead of
   hard-blocking checkout (CART-001 measured the 422 hard block); an empty/absent feed keeps the old
   permissive default so a 0-byte data.js or a load race can never purge a cart. (2) A permanent 4xx
   from /cart/update.js now gets an honest unavailable-item toast instead of the false network-error
   one. See CART-002 change note. */
(function(){const CART_KEY="atlas_cart_v1";function detectCat(name){const s=(name||"").toLowerCase();return/earring|hoop|stud/.test(s)?"earrings":/necklace|pendant|chain/.test(s)?"necklaces":/bracelet|bangle|beads?/.test(s)?"bracelets":(/ring|cuff|signet|band/.test(s),"rings")}window.ATLAS_PRODUCTS_LIVE&&window.ATLAS_PRODUCTS_LIVE.length>0&&window.ATLAS_DATA&&(window.ATLAS_DATA.products=window.ATLAS_PRODUCTS_LIVE.map(function(p){const cat=detectCat(p.name),variants=p.variants||[],stock=variants.reduce(function(s,v){return s+Math.max(v.qty||0,0)},0),availableVariants=variants.filter(function(v){return v.available}),anyAvailable=availableVariants.length>0||p.available,defaultVariant=availableVariants[0]||variants[0];return{id:p.handle,name:p.name,description:p.description||"",price:typeof p.price=="number"?p.price:parseFloat(p.price)||0,cat,status:anyAvailable?stock>0&&stock<5?"low":"in_stock":"sold_out",stock:Math.max(stock,0),sku:(p.handle||"").toUpperCase(),image:p.image,images:p.images||[],options:p.options||[],variants,variantId:defaultVariant?defaultVariant.id:null,shopifyHandle:p.handle}}),window.ATLAS_DATA.categories&&window.ATLAS_DATA.categories.forEach(function(c){c.count=window.ATLAS_DATA.products.filter(function(p){return p.cat===c.slug}).length}));

/* M-052: sellability map straight from window.ATLAS_PRODUCTS_LIVE — same source the block above
   already reads (`v.available` per variant), no new data source, no network round-trip. Built
   independently of the ATLAS_DATA guard above so it works even if that block didn't run. */
const sellableVariants={},variantProductName={};
(window.ATLAS_PRODUCTS_LIVE||[]).forEach(function(p){(p&&p.variants||[]).forEach(function(v){if(v&&v.id!=null){const k=String(v.id);sellableVariants[k]=!!v.available;variantProductName[k]=(p&&p.name)||"That item"}})});
/* CART-002: feedHealthy gates the unknown-variant default. Feed delivered variants -> an unknown id
   means the store no longer knows this variant -> unsellable, purge. Feed delivered nothing (0-byte
   data.js - that exact failure happened 2026-08-28 - or a load race) -> we know nothing -> keep the old
   permissive default and purge nothing. */
const feedHealthy=Object.keys(sellableVariants).length>0;
function isSellable(vid){const k=String(vid);return Object.prototype.hasOwnProperty.call(sellableVariants,k)?sellableVariants[k]:!feedHealthy}

const variantMap={};(window.ATLAS_DATA&&window.ATLAS_DATA.products||[]).forEach(function(p){p.variantId&&(variantMap[p.id]=p.variantId)});

let syncing=!1,pendingResolvers=[];
/* CART-002: true when the most recent sync run got a permanent 4xx (not 408/429) from /cart/update.js */
let lastSyncRejected=!1;

async function fetchWithRetry429(url,opts){let res=await fetch(url,opts);if(res.status===429){await new Promise(function(r){setTimeout(r,700)});res=await fetch(url,opts)}return res}
async function safeJson(res){try{return await res.json()}catch(e){console.warn("[atlas] non-JSON cart response",e);return null}}
async function getRealCart(){const res=await fetchWithRetry429("/cart.js",{method:"GET"});if(!res.ok)return null;return await safeJson(res)}

async function syncCart(){
  if(syncing)return new Promise(function(resolve){pendingResolvers.push(resolve)});
  syncing=!0;lastSyncRejected=!1;let success=!1;
  try{
    const target=localCartItems(),targetMap={};
    target.forEach(function(it){const k=String(it.id);targetMap[k]=(targetMap[k]||0)+(Number(it.quantity)||0)});
    const real=await getRealCart();
    if(real===null){success=!1}
    else{
      const updates={};
      (real.items||[]).forEach(function(line){const k=String(line.variant_id);if(!(k in targetMap))updates[k]=0});
      Object.keys(targetMap).forEach(function(k){updates[k]=targetMap[k]});
      if(Object.keys(updates).length===0){success=!0}
      else{
        const res=await fetchWithRetry429("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({updates:updates})});
        if(res.ok){const data=await safeJson(res);success=data!==null}
        else{success=!1;if(res.status>=400&&res.status<500&&res.status!==408&&res.status!==429)lastSyncRejected=!0;console.warn("[atlas] /cart/update.js failed",res.status)}
      }
    }
  }catch(e){console.error("[atlas] cart sync failed:",e);success=!1}
  finally{syncing=!1;const resolvers=pendingResolvers;pendingResolvers=[];resolvers.forEach(function(r){r(success)})}
  return success
}

let syncTimer;function scheduleSync(){clearTimeout(syncTimer),syncTimer=setTimeout(syncCart,350)}
window.addEventListener("atlas-cart-change",scheduleSync);

function cartSignature(items){const byId={};return(items||[]).forEach(function(it){if(!it||it.id===void 0||it.id===null)return;const key=String(it.id);byId[key]=(byId[key]||0)+(Number(it.quantity)||0)}),Object.keys(byId).sort().map(function(id){return id+":"+byId[id]}).join("|")}

/* M-052: last purge this call, so runCheckoutGate can tell "empty because we just purged a dead
   line" (purge toast already explains it) apart from "cart was already empty" (needs its own toast). */
let lastPurgedNames=[];

/* M-052: localCartItems() now also self-heals atlas_cart_v1 — reads the raw stored lines, drops any
   whose variant isn't sellable, persists the cleaned array back to the SAME key, fires the site's own
   atlas-cart-change event (so the React cart re-renders off the corrected local state — this is also
   what fixes the lying cart total, see notes file), and shows one toast naming what was removed. Every
   caller (syncCart, syncCartOnLoad, runCheckoutGate) goes through this, so a dead line can never survive
   a single call anywhere in the bridge. */
function localCartItems(){
  let raw=[];
  try{raw=JSON.parse(localStorage.getItem(CART_KEY)||"[]")}catch{raw=[]}
  if(!Array.isArray(raw))raw=[];
  const removedNames=[];
  const kept=raw.filter(function(line){
    const vid=line&&(line.variantId||variantMap[line.pid]);
    if(vid&&!isSellable(vid)){
      const name=variantProductName[String(vid)]||(line&&line.name)||"That item";
      if(removedNames.indexOf(name)===-1)removedNames.push(name);
      return!1
    }
    return!0
  });
  lastPurgedNames=removedNames;
  if(removedNames.length>0){
    if(JSON.stringify(kept)!==JSON.stringify(raw)){
      try{localStorage.setItem(CART_KEY,JSON.stringify(kept))}catch(e){console.warn("[atlas] failed to persist purged cart",e)}
      try{window.dispatchEvent(new Event("atlas-cart-change"))}catch(e){}
    }
    showAtlasToast(removedNames.length===1?
      (removedNames[0]+" is no longer available — we've removed it from your cart."):
      ("A few items are no longer available — we've removed them from your cart: "+removedNames.join(", ")+"."));
  }
  return kept.map(function(line){const vid=line.variantId||variantMap[line.pid];return vid?{id:vid,quantity:line.qty}:null}).filter(Boolean)
}
async function syncCartOnLoad(){const localItems=localCartItems();try{const res=await fetch("/cart.js");if(res.ok){const realItems=((await res.json()).items||[]).map(function(it){return{id:it.variant_id,quantity:it.quantity}});if(cartSignature(localItems)===cartSignature(realItems))return}}catch{}await syncCart()}
document.readyState==="loading"?document.addEventListener("DOMContentLoaded",function(){setTimeout(syncCartOnLoad,100)}):setTimeout(syncCartOnLoad,100);

let checkoutInFlight=!1;

async function cartHasTarget(target){
  if(!target||target.length===0)return!1;
  try{
    const res=await fetchWithRetry429("/cart.js",{method:"GET"});
    if(!res.ok)return!1;
    const data=await safeJson(res);
    if(!data)return!1;
    const items=data.items||[];
    return target.every(function(t){return items.some(function(l){return String(l.variant_id)===String(t.id)})})
  }catch(e){return!1}
}

function ensureToastStyles(){
  if(document.getElementById("atlas-toast-style"))return;
  const style=document.createElement("style");
  style.id="atlas-toast-style";
  style.textContent=".atlas-toast{position:fixed;left:50%;bottom:28px;transform:translateX(-50%) translateY(12px);opacity:0;pointer-events:none;background:var(--n-charcoal,#161412);color:var(--n-cream,#E8DCC8);border:1px solid var(--n-gold,#C9A96E);border-radius:0;padding:13px 22px;font-family:var(--font-body,'Raleway',sans-serif);font-weight:400;font-size:.72rem;letter-spacing:.06em;line-height:1.5;max-width:min(92vw,420px);text-align:center;box-shadow:0 16px 48px rgba(0,0,0,.55);z-index:99999;transition:opacity .3s ease,transform .3s ease}.atlas-toast.atlas-toast--show{opacity:1;transform:translateX(-50%) translateY(0);pointer-events:auto}";
  document.head.appendChild(style)
}
let toastTimer,toastEl;
function showAtlasToast(msg){
  ensureToastStyles();
  if(!toastEl){toastEl=document.createElement("div");toastEl.className="atlas-toast";document.body.appendChild(toastEl)}
  toastEl.textContent=msg;
  clearTimeout(toastTimer);
  requestAnimationFrame(function(){toastEl.classList.add("atlas-toast--show")});
  toastTimer=setTimeout(function(){toastEl.classList.remove("atlas-toast--show")},4200)
}

/* M-052: target now comes back pre-purged (localCartItems() self-heals + toasts as it reads). If
   that leaves nothing to check out, refuse to navigate. Only show the generic "cart is empty" toast
   when nothing was just purged this call — otherwise the purge toast above already explains why the
   cart emptied, and we don't want to stomp it with a second, unrelated message a moment later. This
   toast is a different sentence from M-050's "Couldn't reach the store — please try again" network
   toast, so the two stay distinguishable per M-052 requirement 5. */
async function runCheckoutGate(navigate){
  if(checkoutInFlight)return;
  checkoutInFlight=!0;
  try{
    const target=localCartItems();
    if(target.length===0){
      if(lastPurgedNames.length===0)showAtlasToast("Your cart is empty — add something before checking out.");
      return
    }
    await new Promise(function(r){setTimeout(r,360)});
    await syncCart();
    const ok=await cartHasTarget(target);
    if(ok){navigate()}
    else if(lastSyncRejected){showAtlasToast("An item in your cart is no longer available - please refresh the page and try again")}
    else{showAtlasToast("Couldn't reach the store — please try again")}
  }finally{checkoutInFlight=!1}
}

function isCheckoutHref(href){
  if(!href)return!1;
  if(href==="/checkout"||href.indexOf("/checkout?")===0)return!0;
  if(href==="https://atlasforged.co/checkout"||href.indexOf("https://atlasforged.co/checkout?")===0)return!0;
  return!1
}

document.addEventListener("click",function(e){
  const el=e.target.closest&&e.target.closest('a[href], button[name="checkout"], button.cart__checkout-button, [data-checkout-btn]');
  if(!el)return;
  if(el.tagName==="A"){
    const href=el.getAttribute("href");
    if(!isCheckoutHref(href))return;
    e.preventDefault();
    runCheckoutGate(function(){window.location.href=href});
    return
  }
  const form=el.closest("form");
  if(form&&form.__atlasBypass)return;
  e.preventDefault();
  runCheckoutGate(function(){
    if(form){form.__atlasBypass=!0;form.requestSubmit?form.requestSubmit(el):form.submit()}
    else{window.location.href="/checkout"}
  })
},!0);

document.addEventListener("submit",function(e){
  const form=e.target;
  if(!form||form.tagName!=="FORM")return;
  if(form.__atlasBypass){form.__atlasBypass=!1;return}
  let path="";
  try{path=new URL(form.getAttribute("action")||form.action,window.location.href).pathname}catch(err){path=""}
  if(path!=="/checkout")return;
  e.preventDefault();
  const submitter=e.submitter;
  runCheckoutGate(function(){
    form.__atlasBypass=!0;
    form.requestSubmit?form.requestSubmit(submitter||undefined):form.submit()
  })
},!0);

window.atlasSyncCart=syncCart})();
